<template>
  <!-- 订单详情 -->
  <div>
    <div class="order_title" v-if="orderInfo.type == 1">
      待支付（<span>{{ min }}:{{ sec }}</span
      >后订单将自动取消）
    </div>
    <div class="order_title" v-if="orderInfo.type == 2">
      待确认
    </div>
    <div class="order_title" v-if="orderInfo.type == 3">
      待入住
      <el-button class="red order_btn" @click="open">退单</el-button>
    </div>
    <div class="order_title" v-if="orderInfo.type == 4">
      已入住
      <el-button class="red order_btn" @click="open">退单</el-button>
    </div>
    <div class="order_title" v-if="orderInfo.type == 5">
      已离店
    </div>
    <div class="order_title" v-if="orderInfo.type == 8">
      已取消
    </div>
    <div class="homestay_box">
      <div class="homestay_img">
        <img src="../../image/youjia.png" alt="" />悠家民宿
      </div>
      <div class="homestay_number">订单号：{{ orderInfo.id }}</div>
      <div class="homestay_time">下单时间：{{ dateFormat('{y}-{m}-{d} {h}:{i}:{s}',orderInfo.creationTime) }}</div>
    </div>
    <div class="order_title">房屋信息</div>
    <div class="house_info">
      <div class="house_info_img">
        <img src="../../image/bgi-login.png" alt="" />
      </div>
      <div class="house_info_message">
        <div class="house_info_message_title">
          标题：{{ orderInfo.vHousTitle }}
        </div>
        <div class="house_info_message_text">
          {{
            orderInfo.iRenderType == 1
              ? "整套出租"
              : orderInfo.iRenderType == 2
              ? "独立单间"
              : "合住房间"
          }}丨{{ orderInfo.roomNumber }}室丨{{ orderInfo.iBedNumber }}床丨可住{{
            orderInfo.iResidentNum
          }}人
        </div>
        <div class="house_info_message_site">
          房源地址：{{ orderInfo.address }}
        </div>
      </div>
    </div>
    <div class="order_title">入住时间与入住信息</div>
    <div class="dwell_message">
      <div class="dwell_box_top">
        <div class="dwell_info_left">
          订房时间：{{dateFormat('{y}-{m}-{d}',orderInfo.creationTime) }}
<!--            （{{
            this.day==0?1: this.day
          }}晚）-->
        </div>
        <div class="dwell_info_center">
          入住时间：{{ dateFormat('{y}-{m}-{d}',orderInfo.checkInTime) || "信息暂无" }}
        </div>
        <div class="dwell_info_right">
          退房时间：{{ dateFormat('{y}-{m}-{d}',orderInfo.leaveTime) || "信息暂无" }}
        </div>
      </div>
      <div class="dwell_box_bottom">
        <div class="dwell_info_left">
          入住人数：{{ orderInfo.numberOfPeople }}
        </div>
        <div class="dwell_info_center">
          入住客人：{{ orderInfo.userName || "信息暂无" }}
        </div>
        <div class="dwell_info_right">
          联系电话：{{ orderInfo.userPhone }}
        </div>
      </div>
    </div>
    <div class="order_title">支付信息</div>
    <div class="pay_box">
      <div class="pay_box_top">
        <div class="pay_box_left">实收：{{ orderInfo.money }}元</div>
        <div class="pay_box_right">平台佣金：{{ orderInfo.commission }}元</div>
      </div>
      <div class="pay_box_center">
        <div class="pay_box_left">优惠：{{ orderInfo.discount }}元</div>
        <div class="pay_box_right">加客费：{{ orderInfo.addMoney }}元</div>
      </div>
      <!-- <div class="pay_box_bottom">平台代收押金：200元</div> -->
    </div>
    <!-- <div class="order_title">评论</div> -->
  </div>
</template>
<script>
import {cancelMtOrder, getOrdersDetails, wxRefund} from "../../api/index";
import {format} from '@/utils/util'
export default {
  data() {
    return {
      day: "",
      orderNumber: "",
      orderInfo: [],
      creationTime: "",
      timestamp: "",
      countDown: "",
      min: "",
      sec: "",
      moneyBack: {
        outTradeNo: "", //订单号
        refundFee: "", //退款金额
        totalFee: "" //订单金额
      }
    };
  },
  created() {
    if (this.$route.params.orderNumber) {
      sessionStorage.setItem("orderNumber", this.$route.params.orderNumber); //将params中的值存在本地，并且当他为空时不刷新
    }
    this.orderNumber = sessionStorage.getItem("orderNumber");
    this.getOrdersDetailsGet();
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.tim);
  },
  methods: {
      dateFormat(mart,str){
          console.log(mart,str)
          console.log(format(mart,new Date(str)))
          return format(mart,new Date(str))
      },
    async getOrdersDetailsGet() {
      const { data: res } = await getOrdersDetails({ id: this.orderNumber });
      this.orderInfo = res.data;
      this.moneyBack = {
        outTradeNo: this.orderInfo.id, //订单号
        refundFee: this.orderInfo.money, //退款金额
        totalFee: this.orderInfo.money //订单金额
      };
      this.creationTime = new Date(res.data.creationTime).getTime() + 900000;

      this.day =
        (new Date(res.data.leaveTime).getTime() -
          new Date(res.data.checkInTime).getTime()) /
        86400 /
        1000;
        console.log(' this.day', this.day)
      this.countdown();
    },
    countdown() {
      const now = Date.parse(new Date());
      const msec = this.creationTime - now;
      // console.log(msec);
      if (msec > 0) {
        let min = parseInt((msec / 1000 / 60) % 60);
        let sec = parseInt((msec / 1000) % 60);
        this.min = min > 9 ? min : "0" + min;
        this.sec = sec > 9 ? sec : "0" + sec;
        const that = this;
        this.tim = setTimeout(function() {
          that.countdown();
        }, 1000);
      } else {
        clearInterval(this.tim);
      }
    },
    open() {
      console.log(this.orderInfo);
      this.$confirm("退款后订单金额将原路径返还，请谨慎操作!", "提示", {
        confirmButtonText: "确定退款",
        cancelButtonText: "再考虑下",
        type: "warning"
      })
        .then(async () => {
            if(this.orderInfo.dataSources!=3){
                const { data: res } = await wxRefund(this.moneyBack);
                if (res.code !== 200)
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
            }

            //取消美团订单
            if(this.orderInfo.dataSources==3){
                cancelMtOrder({
                    orderId:this.orderInfo.id,
                    cancelReason:'悠家后台主动取消订单'
                }).then(res=>{
                    if(res&&res.data.code==200){
                        console.log('美团订单取消成功')
                    }else {
                        return this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                    }
                })
            }

          this.getOrdersDetailsGet();
          return this.$message({
            message: res.msg,
            type: "success"
          });
        })
        .catch(() => {
          /*this.$message({
            type: "info",
            message: "已取消退款"
          });*/
        });
    }
  }
};
</script>

<style lang="less" scoped>
.order_title {
  position: relative;
  height: 44px;
  padding-left: 19px;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  span {
    color: #f6b439;
  }
}
.order_title::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 4px;
  height: 30px;
  background: #f6b439;
  border-radius: 3px;
}
.homestay_box {
  font-size: 16px;
  position: relative;
  height: 40px;
  margin-bottom: 60px;
  .homestay_img {
    position: absolute;
    top: 0;
    left: 0;
    // width: 40px;
    height: 40px;
    border: 8px;
    img {
      vertical-align: middle;
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .homestay_number {
    position: absolute;
    top: 0;
    left: 244px;
    line-height: 40px;
  }
  .homestay_time {
    position: absolute;
    top: 0;
    left: 546px;
    line-height: 40px;
  }
}
.house_info {
  position: relative;
  height: 100px;
  margin-bottom: 60px;
  .house_info_img {
    position: absolute;
    top: 0;
    left: 0;
    width: 160px;
    height: 100px;
    img {
      width: 160px;
      height: 100px;
    }
  }
  .house_info_message {
    width: 100%;
    position: absolute;
    top: 0;
    left: 180px;
    font-size: 16px;
    line-height: 24px;
    .house_info_message_title {
      position: absolute;
      top: 0;
      left: 0;
    }
    .house_info_message_text {
      position: absolute;
      top: 38px;
      left: 0;
    }
    .house_info_message_site {
      position: absolute;
      top: 76px;
      left: 0;
    }
  }
}
.dwell_message {
  position: relative;
  height: 74px;
  margin-bottom: 60px;
  .dwell_box_top {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    line-height: 24px;
    width: 100%;
    .dwell_info_left {
      position: absolute;
      top: 0;
      left: 0;
    }
    .dwell_info_center {
      position: absolute;
      top: 0;
      left: 415px;
    }
    .dwell_info_right {
      position: absolute;
      top: 0;
      left: 755px;
    }
  }
  .dwell_box_bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 24px;
    line-height: 24px;
    width: 100%;
    .dwell_info_left {
      position: absolute;
      top: 0;
      left: 0;
    }
    .dwell_info_center {
      position: absolute;
      top: 0;
      left: 415px;
    }
    .dwell_info_right {
      position: absolute;
      top: 0;
      left: 755px;
    }
  }
}
.pay_box {
  position: relative;
  height: 132px;
  margin-bottom: 60px;
  .pay_box_top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .pay_box_center {
    position: absolute;
    top: 54px;
    left: 0;
    width: 100%;
  }
  .pay_box_bottom {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
  }
}
.pay_box_left {
  position: absolute;
  left: 0;
  top: 0;
}
.pay_box_right {
  position: absolute;
  left: 307px;
  top: 0;
}

.order_btn {
  float: right;
  width: 72px;
  height: 30px;
  padding: 0;
  color: #fff;
  border-radius: 4px;
}
.red {
  background-color: #f62a2a;
  border: #f62a2a;
}
</style>
